<ul class="navbar-nav d-flex align-items-start mx-auto">
	@if (isPortal) {
		<li class="nav-item">
			<a
				href="javascript:void(0);"
				class="nav-link"
				[ngClass]="{ active: currentTab === 'dashboard' }"
				(click)="navigateTo('dashboard'); closeCanvas()"
				id="topNavDashboard"
				>Dashboard</a
			>
		</li>
		<li class="nav-item">
			<a
				href="javascript:void(0);"
				class="nav-link"
				[ngClass]="{ active: currentTab === 'profile' }"
				(click)="navigateTo('profile'); closeCanvas()"
				id="topNavProfile"
				>Profile</a
			>
		</li>
	} @else {
		<li class="nav-item">
			<a class="nav-link" href="javascript:void(0);" (click)="navigateToSection('howItWorks')" id="topNavHowItWorks">How it works</a>
		</li>
		<li class="nav-item">
			<a class="nav-link" href="javascript:void(0);" (click)="navigateToSection('whoWeAre')" id="topNavWhoWeAre">Who we are</a>
		</li>
		<li class="nav-item">
			<a class="nav-link" href="javascript:void(0);" (click)="navigateToSection('reviews')" id="topNavReviews">Reviews</a>
		</li>
		<li class="nav-item">
			<a class="nav-link" href="javascript:void(0);" (click)="navigateToSection('faq')" id="topNavFaq">FAQ</a>
		</li>
		<li class="nav-item">
			<span class="nav-text"
				>Call us at
				{{ promoCode?.agent.eCommerceWebsite?.contactPhoneNumber | phone: promoCode?.agent.eCommerceWebsite?.contactPhoneNumberCountry?.id }}</span
			>
		</li>
	}
</ul>
<form class="navbar-end-buttons d-xl-flex">
	@if (isLoggedIn) {
		<button class="btn btn-nav-logout" type="button" (click)="logout()">
			<fa-icon [icon]="['fas', 'arrow-right-from-bracket']"></fa-icon> Logout
		</button>
	} @else {
		<button class="btn btn-nav-sign-in" type="button" id="homePageTopNavSignIn" (click)="goLoginPage()">Sign in</button>
		<button class="btn btn-nav-get-rates" type="button" id="homePageTopNavGetRates" (click)="getRates()">Get started</button>
	}
</form>
